import React, { Fragment } from "react";
import {
  Company,
  Country,
  Customer,
  Opportunity,
  OpportunityProspect,
  Product,
  UpdateBeneficiaryInformationFnProps,
  UpdatePaymentInformationFnProps,
} from "../helpers/shared-interfaces";

import jest from "jest-mock";
import Card from "../components/Card";
import { filterProductsByProspect, request } from "../helpers/utilities";
import CompanyDetails from "./BusinessDevelopment/CompanyDetails";
import CustomerDetails from "./BusinessDevelopment/CustomerDetails";
import ProductForm from "./BusinessDevelopment/ProductForm";
import { GET_OPPORTUNITY_FORM_DATA } from "../gql/opportunity";

interface State {
  touchedQueue?: [];
  opportunityProspects: OpportunityProspect[];
}

interface Props {
  name?: string;
  countries: Country[];
  customer?: Customer;
  company?: Company;
  updateData: () => void;
  loadOpportunity: () => void;
  opportunity: Opportunity;
  updateCustomerPaymentInformation: (
    props: UpdatePaymentInformationFnProps,
  ) => void;
  updateCompanyPaymentInformation: (
    props: UpdatePaymentInformationFnProps,
  ) => void;
  updateBeneficiaryInformation: (
    beneficiaryInfo: UpdateBeneficiaryInformationFnProps,
  ) => void;
  editingProduct: boolean;
  editingClientInfo: boolean;
  cancelEdit?: () => void;
  isEditing: boolean;
}

export default class EditOpportunity extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { opportunityProspects: [] };
  }

  getOpportunityCreationData(): void {
    request({
      query: GET_OPPORTUNITY_FORM_DATA,
    }).then((response: any): void => {
      this.setState({
        opportunityProspects: response.data.data.opportunityProspects,
      });
    });
  }

  save = (): void => {
    this.props.updateData();
  };

  componentDidMount(): void {
    this.getOpportunityCreationData();
  }

  render(): JSX.Element {
    const {
      customer,
      countries,
      company,
      opportunity,
      editingProduct,
      editingClientInfo,
    } = this.props;

    const products: Product[] = filterProductsByProspect(
      opportunity,
      this.state.opportunityProspects,
    );

    const subscriptions = opportunity.customerSubscriptions
      ? opportunity.customerSubscriptions
      : [];

    return (
      <Fragment>
        <Card>
          <div data-testid="edit-opportunity">
            {editingProduct && (
              <ProductForm
                opportunityPreview={null}
                getNextViewName={jest.fn()}
                getPreviousViewName={jest.fn()}
                setPercentage={jest.fn()}
                petraProducts={products}
                opportunity={opportunity}
                prev={jest.fn()}
                next={jest.fn()}
                save={this.save}
                editingState={editingProduct}
                cancelEdit={this.props.cancelEdit}
              />
            )}
            {editingClientInfo && customer && (
              <CustomerDetails
                updateCustomerPaymentInformation={
                  this.props.updateCustomerPaymentInformation
                }
                updateBeneficiaryInformation={
                  this.props.updateBeneficiaryInformation
                }
                subscriptions={subscriptions}
                showBeneficiarySection={true}
                editingState={true}
                countries={countries}
                opportunity={opportunity}
                customer={customer}
                save={this.save}
                setPercentage={jest.fn()}
                getNextViewName={jest.fn()}
                getPreviousViewName={jest.fn()}
                prev={jest.fn()}
                next={jest.fn()}
                loadOpportunity={this.props.loadOpportunity}
                showOnboardingDetailsSection={true}
                cancelEdit={this.props.cancelEdit}
              />
            )}
            {editingClientInfo && company && (
              <CompanyDetails
                updateCompanyPaymentInformation={
                  this.props.updateCompanyPaymentInformation
                }
                loadOpportunity={this.props.loadOpportunity}
                opportunity={opportunity}
                editingState={true}
                save={this.save}
                countries={countries}
                company={company}
                setPercentage={jest.fn()}
                getNextViewName={jest.fn()}
                getPreviousViewName={jest.fn()}
                prev={jest.fn()}
                next={jest.fn()}
                showOnboardingDetailsSection={true}
                companyContacts={company.companyContacts}
                cancelEdit={this.props.cancelEdit}
                isEditing={true}
              />
            )}
          </div>
        </Card>
      </Fragment>
    );
  }
}
